import styles from './hint.module.css'
import { Icon } from '../icon/icon'

type Props = {
    text: string
    className?: string
}

export const Hint = (props: Props) => {
    const { text, className } = props
    
    return <p className={`${styles.text} ${className || ''}`}>
        <Icon
            icon='info-circle'
            color='tertiary'
            className={styles.leftMargin}
            small
            rightMargin
        />
        {text}
    </p>
}
